module.exports = __webpack_public_path__ + "img/wxKfSrc.56f4ea87.jpg";